import { Outlet } from '@tanstack/react-router';

export const StrategiesLayout = () => {
  // No outer padding: the strategies views are full-bleed (Figma App.tsx
  // renders them edge-to-edge). The dashboard's first-layer nav and the
  // ETF-designer header span border-to-border; each view applies its own
  // content padding below its full-width chrome. (The Report escapes this
  // layout entirely via `fixed inset-0`, so it's unaffected.)
  return (
    <div className="h-full w-full bg-background flex flex-col">
      <main className="w-full flex-1 min-h-0">
        <Outlet />
      </main>
    </div>
  );
};
